import BaseSetup from '@/components/BaseSetup';
import { OTP_TYPE } from '@/typings/OTP_TYPE';
import { formatPhone } from '@/utils/tools';

export type SharedOtpChannelPickerEmits = {
	(e: 'update:modelValue', v: OTP_TYPE): void
};

export type SharedOtpChannelPickerProps = {
	modelValue: OTP_TYPE
	phone?: Nullable<string>
	email: string
};

export default class SharedOtpChannelPickerSetup extends BaseSetup {

	static readonly defaultProps = { phone: null };

	get smsDisabled () { return !this.props.phone?.trim() }
	get phoneFormatted () { return formatPhone(this.props.phone ?? '') }
	get isSmsSelected () { return this.props.modelValue === OTP_TYPE.SMS }
	get isMailSelected () { return this.props.modelValue === OTP_TYPE.EMAIL }
	get smsDisabledTooltip () { return this.smsDisabled ? this.$t('signature.otp.smsDisabledNoPhone') : undefined }
	get email () { return this.props.email }

	constructor (
		private props: SharedOtpChannelPickerProps,
		private emits: SharedOtpChannelPickerEmits,
	) {
		super();
	}

	selectSms () {
		if (this.smsDisabled) return;
		this.emits('update:modelValue', OTP_TYPE.SMS);
	}

	selectMail () {
		this.emits('update:modelValue', OTP_TYPE.EMAIL);
	}

}
